class KlaviyoFutureLetter {
    /**
     * @param {Element} container
     */
    constructor(container) {
      if (!(container instanceof HTMLElement)) return;
  
      /** @type {HTMLElement} */
      this.container = container;
  
      /** @type {HTMLFormElement | null} */
      this.form = this.container.querySelector('form');
  
      /** @type {HTMLElement | null} */
      this.responseDiv = this.container.querySelector('.js-ft-response');
  
      /** @type {HTMLInputElement | null} */
      this.emailInput = this.container.querySelector('input[type="email"]');
  
      /** @type {HTMLTextAreaElement | null} */
      this.letterInput = this.container.querySelector('textarea');
  
      /** @type {HTMLButtonElement | null} */
      this.submitBtn = this.container.querySelector('button[type="submit"]');
  
      /** * @type {{ publicKey: string, listId: string, apiRevision: string, endpoint: string }} 
       */
      this.config = {
        publicKey: this.container.dataset.publicKey || '',
        listId: this.container.dataset.listId || '',
        apiRevision: '2024-02-15',
        endpoint: 'https://a.klaviyo.com/client/subscriptions/'
      };
  
      this.init();
    }
  
    init() {
      if (!(this.form instanceof HTMLFormElement)) return;
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  
    /**
     * @param {SubmitEvent} event
     */
    async handleSubmit(event) {
      event.preventDefault();
  
      if (!(this.emailInput instanceof HTMLInputElement) || !(this.letterInput instanceof HTMLTextAreaElement)) return;
  
      const email = this.emailInput.value;
      const letter = this.letterInput.value;
  
      this.setLoadingState(true);
  
      try {
        await this.sendToKlaviyo(email, letter);
        this.showSuccess();
      } catch (error) {
        // Fails silently in production
      } finally {
        this.setLoadingState(false);
      }
    }
  
    /**
     * @param {string} email
     * @param {string} letter
     */
    async sendToKlaviyo(email, letter) {
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'NY Pop-Up Experience',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Future_Letter_Content': letter
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.config.listId
              }
            }
          }
        }
      };
  
      const response = await fetch(`${this.config.endpoint}?company_id=${this.config.publicKey}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': this.config.apiRevision
        },
        body: JSON.stringify(payload)
      });
  
      if (!response.ok) {
        const errorDetails = await response.json();
        throw errorDetails; 
      }
  
      return response;
    }
  
    showSuccess() {
      if (this.form instanceof HTMLFormElement) {
        this.form.style.display = 'none';
      }
      if (this.responseDiv instanceof HTMLElement) {
        this.responseDiv.style.display = 'block';
      }
    }
  
    /**
     * @param {boolean} isLoading
     */
    setLoadingState(isLoading) {
      if (!(this.submitBtn instanceof HTMLButtonElement)) return;
  
      if (isLoading) {
        this.submitBtn.disabled = true;
        this.submitBtn.style.opacity = '0.5';
        this.submitBtn.style.cursor = 'not-allowed';
      } else {
        this.submitBtn.disabled = false;
        this.submitBtn.style.opacity = '1';
        this.submitBtn.style.cursor = 'pointer';
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    const futureLetterContainers = document.querySelectorAll('.js-future-letter-container');
    futureLetterContainers.forEach(container => new KlaviyoFutureLetter(container));
  });